"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["color", "size"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var HomeSolar = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  var {
    color,
    size
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: size,
    height: size,
    fill: color
  }, rest), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("style", null, ".a{fill:none;}.b{fill:#4a4a4a;}")), /*#__PURE__*/_react.default.createElement("defs", null), /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(104 -0.411)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    className: "a",
    width: "16",
    height: "16",
    transform: "translate(-104 0.411)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "b",
    d: "M-101.506,16.358a.494.494,0,0,1-.494-.494V9.426a.493.493,0,0,1,.1-.3l1.486-1.982a.54.54,0,0,1,.4-.2h4.953a.5.5,0,0,1,.35.145l3.963,3.963h0a.541.541,0,0,1,.145.35v3.962h.826a.494.494,0,0,1,.494.494.494.494,0,0,1-.494.494Zm8.915-2.477v1.486h.991V11.9h-3.962v3.467h.991V13.882a.992.992,0,0,1,.991-.991.993.993,0,0,1,.992.992Zm-8.42-4.292v5.778h4.457V11.611L-99.965,8.2Zm7.634,1.32H-92.3l-.99-.99h-1.078Zm-2.476,0h1.078l-.991-.99h-1.077Zm.494-1.981h1.078l-.991-.99h-1.077Zm-2.477,0h1.077l-.991-.99h-1.077Zm7.72-.493V7.941a.494.494,0,0,1,.494-.494.494.494,0,0,1,.493.494v.494a.494.494,0,0,1-.493.493.494.494,0,0,1-.492-.494Zm-3.007-.956a.494.494,0,0,1,0-.7l0,0,.35-.35a.493.493,0,0,1,.7,0l0,0a.494.494,0,0,1,0,.7l0,0-.35.35a.494.494,0,0,1-.35.146.5.5,0,0,1-.348-.146Zm1.75-1.75a2.477,2.477,0,0,1,0-3.5c.036-.036.074-.072.112-.106a.494.494,0,0,1,.7.042l0,0a.494.494,0,0,1-.043.7l0,0a1.485,1.485,0,0,0-.133,2.1c.021.024.043.047.065.069a1.484,1.484,0,0,0,2.1,0c.023-.023.046-.047.067-.072a.494.494,0,0,1,.7-.047l0,0a.494.494,0,0,1,.048.7l0,0a2.456,2.456,0,0,1-1.852.837,2.48,2.48,0,0,1-1.753-.726Zm-2.706-1.256a.494.494,0,0,1-.494-.494.494.494,0,0,1,.494-.494h.494a.493.493,0,0,1,.493.494.493.493,0,0,1-.493.494Z",
    transform: "translate(-0.974 -0.973)"
  })));
});
HomeSolar.propTypes = {
  color: _propTypes.default.string,
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onClick: _propTypes.default.func
};
HomeSolar.defaultProps = {
  color: 'currentColor',
  size: '1em',
  onClick: () => {}
};
var _default = HomeSolar;
exports.default = _default;